// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Results_wrapper__2ctR3","ellipsis":"Results_ellipsis__4jwlS"};